import { Button } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { userState } from "../../interface/MainInterface";

interface propsType {
  userState: userState;
  handleRoomButtonClick: (time: string) => void;
  reserv_time: string[];
  selectedTimes: string[];
  chunkNum: number;
  times: string[];
}

const ReservRoomList = (props: propsType) => {
  const chunkTimeValues = (values: string[], size: number): string[][] => {
    return values.reduce((chunks, value, index) => {
      const chunkIndex = Math.floor(index / size);
      if (!chunks[chunkIndex]) {
        chunks[chunkIndex] = [];
      }
      chunks[chunkIndex].push(value);
      return chunks;
    }, [] as string[][]);
  };

  const timeValueChunks = chunkTimeValues(props.reserv_time, props.chunkNum);

  return (
    <div className="hp-time-grid">
      <List sx={{ width: "100%" }}>
        {timeValueChunks.map((chunk, index) => (
          <ListItem
            key={index}
            sx={{ display: "flex", justifyContent: "center", padding: 0 }}
          >
            {chunk.map((timeValue) => (
              <Button
                key={timeValue}
                className={`hp-time-slot${props.selectedTimes.includes(timeValue) ? " is-selected" : ""}${
                  props.times.includes(timeValue) ? " is-unavailable" : ""
                }`}
                disabled={props.times.includes(timeValue)}
                aria-pressed={props.selectedTimes.includes(timeValue) && !props.times.includes(timeValue)}
                variant="outlined"
                sx={{
                  borderRadius: "10px",
                  color: "black",
                  border: "1px solid #ccc",
                  minWidth: "80px",
                  margin: 0,
                  marginRight: 2,
                  marginTop: 1,
                  opacity: props.times.includes(timeValue) ? 0.5 : 1,
                }}
                style={{
                  borderColor: props.times.includes(timeValue)
                    ? "#cccccc"
                    : "#2E3341",
                  color:
                    props.selectedTimes.includes(timeValue) &&
                    !props.times.includes(timeValue)
                      ? "#ffffff"
                      : "#2E3341",
                  backgroundColor:
                    props.selectedTimes.includes(timeValue) &&
                    !props.times.includes(timeValue)
                      ? "#2E3341"
                      : "",
                  pointerEvents: props.times.includes(timeValue)
                    ? "none"
                    : "auto",
                }}
                onClick={() => props.handleRoomButtonClick(timeValue)}
              >
                {timeValue}
              </Button>
            ))}
            {chunk.length < props.chunkNum &&
              Array.from({ length: props.chunkNum - chunk.length }, (_, i) => (
                <Button
                  key={`empty-${i}`}
                  className="hp-time-slot hp-time-slot--placeholder"
                  aria-hidden="true"
                  tabIndex={-1}
                  sx={{
                    borderRadius: "10px",
                    color: "black",
                    border: "0px solid #ccc",
                    minWidth: "80px",
                    margin: 0,
                    marginRight: 2,
                    marginTop: 1,
                  }}
                />
              ))}
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default ReservRoomList;
